module.exports = __webpack_public_path__ + "img/king-on-africa.3cca9d1b.jpg";